export default __webpack_public_path__ + "images/502ad3f51be5b23b562622886991c36e.svg";